import React, { Suspense } from 'react';
import PageSkeleton from './PageSkeleton';

export default function SuspensePage({ children }: any) {
  return <Suspense fallback={<PageSkeleton />}>{children}</Suspense>;
}
